<div *ngIf="inProgressGetShape">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  loading....
</div>

<div class="center-content armabox medium-border-arma-color" style="flex-flow: initial; height: 94%; width: 796px;">

  <form class="example-form form armarow content formIE">
    <mat-form-field class="example-full-width">
      <mat-label>{{"Code" | translate}}</mat-label>
      <input matInput (keydown)="onKeyCodeDown($event)" (keyup)="onFilterChange()" [(ngModel)]="HTML_INPUT_FILTER" (ngModelChange)="HTML_INPUT_FILTER = $event.toUpperCase()" [ngModelOptions]="{standalone: true}" placeholder="exemple: 10B" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Nombre de plis" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_PLIURE" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let input of mInput" [value]="input.value">{{input.viewValue | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "côte" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_MEASURE" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let input of mInput" [value]="input.value">{{input.viewValue | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Arc" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_ARC" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let input of mInput" [value]="input.value">{{input.viewValue | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "3D" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_3D" [ngModelOptions]="{standalone: true}">
        <option value="any">{{"Any" | translate}}</option>
        <option value="yes">{{"Oui" | translate}}</option>
        <option value="no">{{"Non" | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Rayon" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_RADIUS" [ngModelOptions]="{standalone: true}">
        <option value="any">{{"Any" | translate}}</option>
        <option value="yes">{{"Oui" | translate}}</option>
        <option value="no">{{"Non" | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Diameter" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_DIAMETER" [ngModelOptions]="{standalone: true}">
        <option value="any">{{"Any" | translate}}</option>
        <option value="yes">{{"Oui" | translate}}</option>
        <option value="no">{{"Non" | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Angles à 180" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_180ANGLES" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let input of mInput" [value]="input.value">{{input.viewValue | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Angles à 90°" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_90ANGLES" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let input of mInput" [value]="input.value">{{input.viewValue | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Angles à 135°" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_135ANGLES" [ngModelOptions]="{standalone: true}" >
        <option *ngFor="let input of mInput" [value]="input.value">{{input.viewValue | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Angles à 45°" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_45ANGLES" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let input of mInput" [value]="input.value">{{input.viewValue | translate}}</option>
      </select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Coupleurs" | translate }} </mat-label>
      <select matNativeControl (change)="onFilterChange()" [(ngModel)]= "HTML_INPUT_COUPLERS" [ngModelOptions]="{standalone: true}">
        <option value="any">{{"Any" | translate}}</option>
        <option value="yes">{{"Oui" | translate}}</option>
        <option value="no">{{"Non" | translate}}</option>
      </select>
    </mat-form-field>

  </form>

  <div class="armabox left-medium-border-arma-color ieonly">
    <div #scroll class="armarow content tableIE" style="width: 100%; overflow-y: scroll;">
      <table
        mat-table
        #table
        [dataSource]="HTML_TABLE_DATASOURCE">
        <!-- Colonne des Shapes -->
        <ng-container matColumnDef="SHAPE">
          <th style="text-align: center; width: 100%;" mat-header-cell *matHeaderCellDef>
            {{ "Formes" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{element.Forme.CodeForme}}
            <div style="text-align: center;">
              <!-- <mat-spinner *ngIf="!element.interfaceshape_img;"></mat-spinner> -->
              <arma-shape
              [shape] ="element.Forme"
              width = "300"
              height = "150"
              [Entermeasure] = "false"
              *ngIf="!element.interfaceshape_img;"
              id="example-forme-trace-{{element.Forme.CodeForme}}">
            </arma-shape>
              <img style="height: 150px;" [src]="element.interfaceshape_img" />
            </div>
          </td>
        </ng-container>

        <!-- Colonne pour le téléchargement -->
        <ng-container matColumnDef="Action">
          <th style="text-align: center; width: 100%;" mat-header-cell *matHeaderCellDef>
            {{ "Télécharger" | translate }}
          </th>
          <td mat-cell style="padding: 24px;" *matCellDef="let element">
            <button class="btndownload" mat-stroked-button (click)="DownloadShape(element)">{{ "Télécharger" | translate }}</button>
          </td>
        </ng-container>

        <tr mat-header-row class="armaor-background-color tr-header" *matHeaderRowDef="HTML_TABLE_HEADER_COL; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: HTML_TABLE_HEADER_COL"></tr>
      </table>
    </div>
    <div class="armarow footer">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize] = "10" [hidePageSize]="true" showFirstLastButtons (page)="onPageChange()"></mat-paginator>
    </div>
  </div>
</div>
